import sum from 'lodash/sum';
import { useTranslation } from 'react-i18next';

import { useSidePanelDiagonalCornerTab } from './hooks';

import { IMAGE_COMING_SOON, UNIT_MEASURE } from '~/core/constants';
import { CircleAction, DiagonalCornerOptions } from '~/core/enums';
import { getCornerType } from '~/core/helpers';
import { DiagonalCornerModel } from '~/core/models';
import {
  formatPriceUnitOrFree,
  getProductDescription,
  imgUrl,
} from '~/core/utils';
import SidePanelSectionTab from '~organisms/SidePanelSectionTab';

export const SidePanelDiagonalCornerTab = () => {
  const { t } = useTranslation();
  const {
    isFetchingDiagonalCorners,
    diagonalCorners,
    handleUpdate,
    optionsCounters,
    isInteriorDiagonalCornerEnabled,
  } = useSidePanelDiagonalCornerTab();
  const optionName = {
    option: t('SCROLLABLE_AREA.DIAGONAL_CORNER.OPTION_NAME'),
  };

  return (
    <SidePanelSectionTab<DiagonalCornerModel>
      title={t('SCROLLABLE_AREA.DIAGONAL_CORNER.TITLE')}
      description={t('SCROLLABLE_AREA.DIAGONAL_CORNER.DESCRIPTION')}
      selectOptionText={t('DESIGN_TOOLBAR.SELECT', optionName)}
      removeModalTitle={t(
        'SCROLLABLE_AREA.DIAGONAL_CORNER.REMOVE_MODAL.TITLE',
        optionName
      )}
      removeModalDescription={t(
        'SCROLLABLE_AREA.DIAGONAL_CORNER.REMOVE_MODAL.DESCRIPTION',
        optionName
      )}
      hookArgs={{
        options: diagonalCorners,
        isFetching: isFetchingDiagonalCorners,
        stateRemoveOption: handleUpdate(CircleAction.REMOVE),
        stateAddOption: handleUpdate(CircleAction.ADD),
        optionsCounters,
        getId: (option) => option.name,
        countersLimit: sum(Object.values(optionsCounters)),
        mapOptionToDisplay: (option) => ({
          title: getProductDescription(option),
          image: option.imageUrl
            ? imgUrl(option.imageUrl, 300)
            : IMAGE_COMING_SOON,
          price: formatPriceUnitOrFree(
            option.price,
            option.unitOfMeasure || UNIT_MEASURE.CORNER_RADIUS,
            true
          ),
          isDisabled:
            getCornerType(option) === DiagonalCornerOptions.INSIDE_CORNER &&
            !isInteriorDiagonalCornerEnabled,
        }),
      }}
    />
  );
};

export default SidePanelDiagonalCornerTab;
